<template>
	<div>
		<a-modal v-show='!ishand' id='xiangqing' width='45rem' v-model="visible" on-ok="handleOk1"
			v-dragModal :dialog-style="{ top: '20vh' }"
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'><div v-html='"申購詳情"' style="width: 43rem;"></div></div>
			<div solt='title'>
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="width: 43rem;" class='body_lis'>
				<div style="padding-top: 1rem;">
					<a-form-model ref='form' :model="form" labelAlign='left' layout="inline" 
						hideRequiredMark v-if='false'>
							<a-form-model-item prop='remark' label='證券帳號'>{{record.username}}</a-form-model-item>
							<a-form-model-item prop='remark' label='電話號碼'>{{record.mobile}}</a-form-model-item>
							<a-form-model-item prop='remark' label='出生日期'>
							<div v-if='record.khuser_flag'>
								{{record.birth}}
								<!-- <img src="require('@/image/lea/bianji4.png')" alt=""> -->
							</div>
							<div v-else>
								<a-date-picker v-model='form.birth' @change="onChange" placeholder=' ' v-if='useradmin'/>
								<img :src="require('@/image/baocun.png')" alt="" 
								 style="margin-left: 1rem;"  v-if='useradmin'>
							</div>
							</a-form-model-item>
							<a-form-model-item prop='remark' label='上次登入'>{{record.logintime}}</a-form-model-item>
							<div id='whand'>
							<a-form-model-item prop='remark' label='電子郵箱' style='width: 100%;'>{{record.email}}</a-form-model-item></div>
					</a-form-model>
					<table style="width: 100%;border-color: #d8d8d8;font-size: .8rem;" border="1">
						<tr v-for='(item,ind) in tabefrom' :key="ind" :rowClassName="tableRowClass" :style='{background:(ind%2==0)?"#f9f9f9":""}' style="width: 50%;">
							
							<td v-if="item.a == '電郵地址'"><div style="display: flex;padding: 10px 0;"><div v-html='item.a' style="padding-left: 2rem;"></div>
							<div style="margin-left: 2rem;">{{params[item.an]}}</div></div></td>
							<td v-else><div style="display: flex;padding: 10px 0;"><div v-html='item.a' style="padding-left: 2rem;"></div>
							<div style="margin-left: 2rem;">{{params[item.an]}}</div></div></td>
							<td><div style="display: flex;padding: 10px 0;"><div v-html='item.b' style="padding-left: 2rem;"></div>
							<div style="margin-left: 2rem;">{{params[item.bn]}}</div></div></td>
						</tr>
					</table>
				</div>
				<div style="display: flex;justify-content: space-between;margin: 1.5rem 0 .5rem;" v-if='params.aduit&&(params.status !=="申請成功")' >
					<div class="btnshenqing" style="background-color:#f48d28;" @click='getfrom(3)'>取消申請</div>
					<div class="btnshenqing" style="background-color:#ed4849;" @click='getfrom(2)'>申請失敗</div>
					<div class="btnshenqing" style="background-color:#0c8b97;" @click='getfrom(1)'>申請成功</div>
				</div>
			</div>
			
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	
	export default {
		props: ['record'],
		data() {
			return {
				useradmin: this.$store.state.rolesdata.indexOf('useradmin') >= 0,
				ishand: false,
				visible: true,
				form: {
					birth:''
				},
				params:{
					status2:''//  0 提交申請 1 申請成功 2 申請失敗 3 取消申請
				},
				tabefrom:[
					{
						a:'證券帳號',
						an:'username',
						bn:'realname',
						b:'中文名稱'
					},
					{
						a:'電郵地址',
						b:'電話號碼',
						an:'email',
						bn:'mobile',
					},
					{
						a:'股票代碼',
						b:'申請數量',
						an:'stockcode',
						bn:'amount',
					},{
						a:'申請金額',
						b:'貸款金額',
						an:'price',
						bn:'loan_price',
					},{
						a:'貸款比率',
						b:'貸款息率',
						an:'max_loan_rate',
						bn:'loan_rate',
					},
					{
						a:'利&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;息',
						b:'提交時間',
						an:'interest',
						bn:'createtime',
					},
					{
						a:'分配结果',
						b:'上市日期',
						an:'resultdate',
						bn:'listingdate',
					}
				]
			}
		},
		created() {
			let _this = this
			_this.form = JSON.parse(JSON.stringify(_this.record))
			if(_this.form.birth){
				let arr = _this.form.birth.split('/')
				arr = arr.reverse()
				 _this.form.birth = arr.join('-')
			}
		},
		mounted(){
			this.getdate() 
		},
		methods: {
			getdate(){
				this.$ajax({
					method:'post',
					url:this.$api.getUserApplyRecordWithApplyid,
					data:{
						applyid:this.record.applyid
					}
				}).then(res=>{
					if(res.data.qmiscode == 1000){
						this.params = res.data
					}else{
						this.$message.warning(res.data.qmismsg)
					}
				})         
			}, 
			getfrom(val){
				// this.form.birth = new Date(this.form.birth)
				// this.form.birth = this.form.birth ? App.oDate.secsTime3(this.form.birth) : '';
				this.$ajax({
					method:'post',
					url:this.$api.newUserApplyAudit,
					data:{
						"applyid":this.record.applyid,
						"status":val
					}
				}).then(res=>{
					if(res.data.qmiscode===1000){
						// this.$emit('child', 1)
						this.$message.success(res.data.qmismsg);
						this.visible = false;
						// this.getdate();
						// this.getUserApplyRecordList();
						this.$emit('getUserApplyRecordList');
					}else{
						this.$message.warning(res.data.qmismsg)
					}
				})
			},
			onChange(){},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {},
			tableRowClass(record) {
   	        	return record.status=== "申请成功" ? "rowClass" : "#f9f9f9";
		},
		},
		
 	    
		
	}
</script>

<style lang="scss">
	.btnshenqing{
		width: 8rem;
		text-align: center;
		padding: 10px 0;
		color: #fff;
		font-size: .8rem;
		border-radius: 4px;
		cursor: pointer;
	}
	#xiangqing{
		#whand{
			.ant-form-item-label {
				width: 9% ;
			}
		}
	}
	#xiangqing .ant-modal-header,
	#xiangqing .ant-modal-body {
		background-color: #e5e5e5 !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	#xiangqing {
		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}
		.ant-form-item-label {
			width: 18%;
		}
		.ant-form-item{
			width: 50%;
		}
		.ant-form-item label {
			font-size: .8rem !important;
		}
		.ant-form-item-children{
			font-size: .8rem !important;
		}
		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}
	}
</style>
